import { render, staticRenderFns } from "./detailTable10.vue?vue&type=template&id=10bfb478&scoped=true&"
import script from "./detailTable10.vue?vue&type=script&lang=js&"
export * from "./detailTable10.vue?vue&type=script&lang=js&"
import style0 from "./detailTable10.vue?vue&type=style&index=0&id=10bfb478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bfb478",
  null
  
)

export default component.exports